"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Score = void 0;
class Score {
    constructor(account, protocol, score, epoch, merkleProof, metadata) {
        this.account = account;
        this.protocol = protocol;
        this.score = score;
        this.epoch = epoch;
        this.merkleProof = merkleProof;
        this.metadata = metadata;
    }
    static getValidationMap() {
        return {
            account: 'string',
            protocol: 'string',
            score: 'string',
        };
    }
}
exports.Score = Score;
//# sourceMappingURL=scores.model.js.map